// Cross-venue divergence badge — a small violet pill shown on a trader's
// order/position when Polymarket's mid has pulled >= 2¢ from Kalshi (and the
// poly book is fresh enough to trust). Self-gating: renders nothing unless the
// gap is active, so every call site is a one-liner. The persistent counterpart
// to the one-shot .animate-divergence-flash card cue.

import type { DivergenceInfo } from '@/lib/divergence/polyKalshiDivergence';
import {
  fmtDivergenceBadge,
  divergenceTooltip,
  isDivergenceActive,
} from '@/lib/divergence/polyKalshiDivergence';

export function DivergenceBadge({
  info,
  className = '',
}: {
  info: DivergenceInfo | null | undefined;
  className?: string;
}) {
  if (!isDivergenceActive(info)) return null;
  return (
    <span
      title={divergenceTooltip(info)}
      className={`inline-flex shrink-0 items-center gap-1 rounded-full bg-violet-500/15 px-1.5 py-0.5 text-[10px] font-semibold text-violet-300 light:bg-violet-500/20 light:text-violet-700 ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-violet-400 light:bg-violet-600" />
      {fmtDivergenceBadge(info)}
    </span>
  );
}
